import { DiscountsList } from 'components/discounts/DiscountsList/DiscountsList'

export const ProfileDiscountsList: React.FC = () => {
  return <DiscountsList />
}
